import {CountableTaskSet, plannedInstanceCount} from './useTaskSetPreview';

/** The stored fields the denominator needs. Structural, like CountableTaskSet. */
export interface ChipTotalTaskSet extends CountableTaskSet {
	readonly instanceCount?: number | null;
}

/**
 * The denominator for "3 of 26", shared by the timeline bar and the task modal.
 *
 * The scoping chip is NOT a caller: TaskSetChip.tsx is handed `plannedCount` and
 * `instanceCount` as props by ProjectScopingPage.tsx and states the same
 * preference inline, because it is presentation over two numbers rather than
 * over a task set. The rule therefore still lives in two places -- a change here
 * is a change there.
 *
 * What the rule promised is preferred over how many instances survive, so
 * deleting an instance cannot turn "3 of 26" into "3 of 2". Only a COUNT bound
 * states a planned length -- sized from the rule, since the stored count is a
 * number of weeks for a weekly set -- so a DATE-bounded set falls back to the
 * live instanceCount: without that fallback every date-bounded set would lose
 * its label in one place while keeping it in another.
 *
 * Lived in task_item.js as `getChipTotal` until PIKA-789 needed it from the task
 * modal too.
 */
export const taskSetChipTotal = (taskSet?: ChipTotalTaskSet | null): number | null => {
	if (!taskSet) {
		return null;
	}
	const plannedCount = plannedInstanceCount(taskSet);
	if (plannedCount != null) {
		return plannedCount;
	}
	return taskSet.instanceCount != null ? taskSet.instanceCount : null;
};
